/**
 * Constantes pour le système de notification
 * @module config/notificationConstants
 */

/**
 * Types de notifications disponibles
 */
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

/**
 * Durées d'affichage par défaut (en millisecondes)
 */
export const NOTIFICATION_DURATIONS = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 8000,
  PERSISTENT: false, // Ne se ferme pas automatiquement
};

/**
 * Positions possibles pour les notifications
 */
export const NOTIFICATION_POSITIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
};

/**
 * Configurations par défaut pour chaque type de notification
 */
export const NOTIFICATION_DEFAULTS = {
  [NOTIFICATION_TYPES.SUCCESS]: {
    autoClose: NOTIFICATION_DURATIONS.MEDIUM,
    position: NOTIFICATION_POSITIONS.TOP_RIGHT,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
  [NOTIFICATION_TYPES.ERROR]: {
    autoClose: NOTIFICATION_DURATIONS.LONG,
    position: NOTIFICATION_POSITIONS.TOP_RIGHT,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
  [NOTIFICATION_TYPES.INFO]: {
    autoClose: NOTIFICATION_DURATIONS.MEDIUM,
    position: NOTIFICATION_POSITIONS.TOP_RIGHT,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
  [NOTIFICATION_TYPES.WARNING]: {
    autoClose: NOTIFICATION_DURATIONS.MEDIUM,
    position: NOTIFICATION_POSITIONS.TOP_RIGHT,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
};

/**
 * Messages d'erreur standardisés
 */
export const ERROR_MESSAGES = {
  GENERIC: 'Une erreur inattendue s\'est produite',
  NETWORK: 'Erreur de connexion. Vérifiez votre connexion internet.',
  UNAUTHORIZED: 'Vous devez être connecté pour effectuer cette action',
  FORBIDDEN: 'Vous n\'avez pas les permissions nécessaires',
  NOT_FOUND: 'Ressource introuvable',
  VALIDATION: 'Les données fournies ne sont pas valides',
  SERVER: 'Erreur serveur. Veuillez réessayer plus tard.',
  TIMEOUT: 'La requête a expiré. Veuillez réessayer.',
};

/**
 * Messages de succès standardisés
 */
export const SUCCESS_MESSAGES = {
  SAVED: 'Données enregistrées avec succès',
  UPDATED: 'Mise à jour effectuée avec succès',
  DELETED: 'Suppression effectuée avec succès',
  CREATED: 'Création effectuée avec succès',
  CONNECTED: 'Connexion établie avec succès',
  DISCONNECTED: 'Déconnexion effectuée avec succès',
};
